/* Oakman -> Klaviyo signup, shared by every form on the Pre-TENCEL pages.
   Config comes from snippets/oak-klaviyo.liquid (window.OAK_KLAVIYO).
   Uses the public client endpoint, so there is no API key in theme code.
   Resolves on success; rejects with an Error the caller can surface. */
(function(){
  window.oakSubscribe = function(email, source){
    var cfg = window.OAK_KLAVIYO || {};
    if(!cfg.companyId || !cfg.listId){
      return Promise.reject(new Error('OAK_KLAVIYO is not configured'));
    }
    var src = source || cfg.source || 'Oakman site';
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': cfg.revision || '2024-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: src,
              /* NO 'subscriptions' block: the client endpoint rejects it with
                 400 "'subscriptions' is not a valid field for the resource
                 'profile'". Adding the profile to a single opt-in list is what
                 subscribes them. */
              profile: { data: { type: 'profile', attributes: {
                email: email,
                properties: { 'Signup Source': src, 'Founding 100': true }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.listId } } }
          }
        })
      }
    ).then(function(r){
      if(r.status >= 200 && r.status < 300) return true;
      return r.text().then(function(t){
        throw new Error('Klaviyo ' + r.status + ': ' + String(t).slice(0, 300));
      });
    });
  };
})();
